import { motion } from "framer-motion";
import { Phone, ArrowRight, Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const FALLBACK_HERO = "https://images.pexels.com/photos/6873074/pexels-photo-6873074.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export const Hero = ({ content }) => {
  const { t, tc } = useLang();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const heroBtnGhost = "inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm border border-white/40 text-white rounded-full px-7 py-3.5 font-medium hover:bg-white/20 transition-all duration-300";
  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={content.hero_image || FALLBACK_HERO}
          alt="Aufbereitetes Fahrzeug"
          className="w-full h-full object-cover"
          onError={(e) => { if (e.target.src !== FALLBACK_HERO) e.target.src = FALLBACK_HERO; }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/80 to-blue-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-slate-950/50" />
      </div>

      <div className="container-x relative z-10 pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl"
        >
          <div className="flex items-center gap-2 mb-6">
            <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-blue-400 text-blue-400" />)}</div>
            <span className="text-xs sm:text-sm text-blue-300 uppercase tracking-[0.25em] font-semibold">{t("hero.badge")}</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] mb-6">
            {tc(content.hero_title)}
          </h1>
          <p className="text-base md:text-lg text-slate-200 max-w-2xl mb-10 leading-relaxed">
            {tc(content.hero_subtitle)}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button data-testid="hero-cta-appointment" onClick={() => scrollTo("termin")} className="btn-blue">
              {t("hero.cta1")} <ArrowRight className="w-4 h-4" />
            </button>
            <button data-testid="hero-cta-services" onClick={() => scrollTo("leistungen")} className={heroBtnGhost}>
              {t("hero.cta2")}
            </button>
            <a data-testid="hero-cta-call" href={`tel:${content.phone?.replace(/\s/g, "")}`} className={heroBtnGhost}>
              <Phone className="w-4 h-4" /> {t("hero.cta3")}
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2">
        <span className="text-xs text-white/70 tracking-widest uppercase">{t("hero.scroll")}</span>
        <div className="w-px h-12 bg-gradient-to-b from-blue-400 to-transparent" />
      </div>
    </section>
  );
};
